import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  question: 'How quickly can I start accepting donations?',
  answer: "You can be live and accepting donations in as little as 30 minutes. Simply sign up, connect your bank account, and you're ready to go. No lengthy approval processes or complex setup required."
}, {
  question: 'What are the actual costs? Any hidden fees?',
  answer: "We charge a simple 2.5-2.9% + $0.30 per successful transaction. That's it. No setup fees, no monthly fees, no hidden costs. What you see is what you pay."
}, {
  question: 'How does the nonprofit-owned model benefit me?',
  answer: 'As a nonprofit ourselves, we understand your challenges firsthand. We reinvest profits into improving our service and supporting the nonprofit community. Plus, we offer features and pricing specifically designed for nonprofit needs.'
}, {
  question: 'Is my donor data secure?',
  answer: 'Absolutely. We use bank-level encryption and are fully PCI DSS compliant. Your donor data is protected with the same security standards used by major financial institutions.'
}, {
  question: 'Can I accept recurring donations?',
  answer: 'Yes! All plans include recurring donation support. Set up monthly, quarterly, or annual giving programs with automatic processing and donor management.'
}, {
  question: 'What if I need to cancel?',
  answer: 'You can cancel anytime with no penalties or fees. We believe in earning your business every day, not locking you into long-term contracts.'
}, {
  question: 'Do you integrate with my existing tools?',
  answer: 'We offer integrations with popular nonprofit tools and CRMs. Our API also allows custom integrations. Professional and Enterprise plans include priority integration support.'
}, {
  question: 'What kind of support do you offer?',
  answer: 'All plans include email support with quick response times. Professional plans get priority support, and Enterprise customers receive 24/7 phone support with a dedicated account manager.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 lg:py-32 bg-gradient-to-b from-slate-50 to-white" data-id="element-46">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-48">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4" data-id="element-49">
            Frequently asked questions
          </h2>
          <p className="text-xl text-slate-600" data-id="element-50">
            Everything you need to know about Master Merchant
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white rounded-2xl border-2 border-slate-200 overflow-hidden hover:border-orange-200 transition-colors" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left group" data-id="element-53">
                <span className="text-lg font-semibold text-slate-900 pr-8 group-hover:text-orange-600 transition-colors" data-id="element-54">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-100 group-hover:bg-orange-100 flex items-center justify-center transition-colors" data-id="element-55">
                  {openIndex === index ? <MinusIcon className="w-5 h-5 text-slate-600 group-hover:text-orange-600" data-id="element-56" /> : <PlusIcon className="w-5 h-5 text-slate-600 group-hover:text-orange-600" data-id="element-57" />}
                </div>
              </button>
              <AnimatePresence data-id="element-58">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-59">
                    <div className="px-8 pb-6 text-slate-600 leading-relaxed" data-id="element-60">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-12" data-id="element-61">
          <p className="text-slate-600 mb-4" data-id="element-62">Still have questions?</p>
          <a href="#" className="text-orange-600 font-semibold hover:text-orange-700 transition-colors" data-id="element-63">
            Contact our support team →
          </a>
        </motion.div>
      </div>
    </section>;
}